<template>
  <header class="subHeader">
    <div class="content-header">APPROVAL</div>
    <div class="content-body">Review this event for approval.</div>
  </header>
</template>
<script>
export default {
  name: 'subHeaderSubmission',
  methods: {
    sidebarToggle (e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// SubHeaderSubmission.vue?b4ac69d2